var map = {
	"./404.svg": "oUrx",
	"./bug.svg": "F3lI",
	"./car.svg": "7C8n",
	"./chart.svg": "yCkv",
	"./clipboard.svg": "vDVG",
	"./component.svg": "VtY+",
	"./dashboard.svg": "94Jb",
	"./documentation.svg": "kPu2",
	"./drag.svg": "m7++",
	"./edit.svg": "qkZ8",
	"./email.svg": "y7eQ",
	"./example.svg": "MMMJ",
	"./excel.svg": "ZZmv",
	"./exit-fullscreen.svg": "28eg",
	"./eye-open.svg": "1+ww",
	"./eye.svg": "TfVu",
	"./form.svg": "6xvN",
	"./fullscreen.svg": "mSHS",
	"./guide 2.svg": "ICep",
	"./guide.svg": "ZoO1",
	"./icon-news.svg": "wBzG",
	"./icon-receive-text.svg": "HXea",
	"./icon.svg": "nZHn",
	"./international.svg": "F9+T",
	"./language.svg": "JYDz",
	"./link.svg": "GPBF",
	"./list.svg": "MokB",
	"./lock.svg": "qwAt",
	"./logout.svg": "AXUd",
	"./message.svg": "R/8a",
	"./money.svg": "MEYL",
	"./my-file.svg": "EM4x",
	"./my-folder-close.svg": "EOz0",
	"./my-folder-open.svg": "GEln",
	"./my-role.svg": "K7rX",
	"./my-rolesetting.svg": "khOX",
	"./my-sysmenu.svg": "ZYeB",
	"./my-user.svg": "T7O8",
	"./nested.svg": "3PhE",
	"./password.svg": "Kj24",
	"./pdf.svg": "+aF5",
	"./people.svg": "0Fbn",
	"./peoples.svg": "LxGF",
	"./qq.svg": "FDDl",
	"./search.svg": "jo2x",
	"./shopping.svg": "EqXK",
	"./size.svg": "hkRB",
	"./star.svg": "cIpu",
	"./tab.svg": "j7e1",
	"./table.svg": "R/Hx",
	"./theme.svg": "5TQQ",
	"./tree-table.svg": "58g5",
	"./tree.svg": "k80C",
	"./user.svg": "s7Vf",
	"./wechat.svg": "gNoN",
	"./zip.svg": "iqZD"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Uf/o";